import { apiClient } from "../../lib/apiClient";

export interface ResetPasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export interface ResetPasswordResponse {
  message?: string;
}

export interface CreateSuperuserPayload {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export interface CreateSuperuserResponse {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  user_type: string;
}

export interface AdminResetOwnerPasswordPayload {
  email: string;
}

export interface AdminResetOwnerPasswordResponse {
  email: string;
  temp_password: string;
}

export const createSuperuser = async (
  payload: CreateSuperuserPayload
): Promise<CreateSuperuserResponse> => {
  const response = await apiClient.post<CreateSuperuserResponse>(
    "/users/create-superuser",
    {
      email: payload.email,
      password: payload.password,
      first_name: payload.firstName,
      last_name: payload.lastName,
    }
  );
  return response.data;
};

export const adminResetOwnerPassword = async (
  payload: AdminResetOwnerPasswordPayload
): Promise<AdminResetOwnerPasswordResponse> => {
  const response = await apiClient.post<AdminResetOwnerPasswordResponse>(
    "/users/reset-owner-password",
    { email: payload.email }
  );
  return response.data;
};

export interface OwnerSearchItem {
  email: string;
  first_name: string;
  last_name: string;
}

export const searchOwnerAccounts = async (q: string): Promise<OwnerSearchItem[]> => {
  const response = await apiClient.get<OwnerSearchItem[]>("/users/owners", { params: { q } });
  return response.data;
};

export const resetPassword = async (
  payload: ResetPasswordPayload
): Promise<ResetPasswordResponse> => {
  const response = await apiClient.post<ResetPasswordResponse>(
    "/auth/reset-password",
    payload
  );
  return response.data;
};
